module.exports = __webpack_public_path__ + "img/SKMJ_light4.80b706f1.jpg";